export const coverDetailsOpenExcess = {
  membership: {
    composition: 'family',
    excess: 750,
    frequency: 'annual',
    premiumInformation: {
      currentOngoingPremium: 6362.52,
      discounts: {
        rebateDiscount: null,
        abdDiscount: '10%',
        lhcSurcharge: null,
        adfDiscount: '-10%',
        dvaDiscount: null,
        transitionDiscount: null,
        reservistDiscount: null,
      },
    },
  },
  eligibility: { eligibilityType: 'Currently Serving' },
  products: [
    {
      name: 'Advantage Hospital Silver Plus',
      productNumber: 'J22',
      productTypeCode: 1,
      validFromDate: '2019-09-01',
      validToDate: null,
      productExcessType: 527340002,
      stateCode: 0,
      statusCode: 0,
      isEligibleForAbd: '',
      productExcess: [
        {
          excess: 750,
          startDate: '2019-09-01',
          endDate: '',
          composition: '1,2,3,4,6,7',
          eligibilitySegment: '200000000,200000001,200000002,200000003',
          stateCode: 0,
          statusCode: 1,
        },
        {
          excess: 500,
          startDate: '2019-09-01',
          endDate: '',
          composition: '1,2,3,4,5,6,7',
          eligibilitySegment: '200000000,200000001,200000002,200000003',
          stateCode: 0,
          statusCode: 1,
        },
      ],
    },
    {
      name: 'Value Extras',
      productNumber: 'I4',
      productTypeCode: 2,
      validFromDate: '2014-09-01',
      validToDate: null,
      productExcessType: null,
      stateCode: 0,
      statusCode: 0,
      isEligibleForAbd: '',
      productExcess: [],
    },
  ],
};

export const coverDetailsClosedExcess = {
  membership: {
    composition: 'family',
    frequency: 'monthly',
    excess: 500,
    premiumInformation: {
      currentOngoingPremium: 710.71,
      discounts: {
        rebateDiscount: '-16.405%',
        abdDiscount: null,
        lhcSurcharge: null,
        adfDiscount: null,
        dvaDiscount: null,
        transitionDiscount: null,
        reservistDiscount: null,
      },
    },
  },
  eligibility: { eligibilityType: 'Ex-Serving' },
  products: [
    {
      name: 'Premier Extras',
      productNumber: 'I3',
      productTypeCode: 2,
      validFromDate: '2014-09-01',
      validToDate: null,
      productExcessType: null,
      stateCode: 0,
      statusCode: 0,
      isEligibleForAbd: '',
      productExcess: [],
    },
    {
      name: 'Ultimate Hospital Gold',
      productNumber: 'J19',
      productTypeCode: 1,
      validFromDate: '2017-12-01',
      validToDate: null,
      productExcessType: 527340002,
      stateCode: 0,
      statusCode: 0,
      isEligibleForAbd: '',
      productExcess: [
        {
          excess: 500,
          startDate: '2017-12-01',
          endDate: '',
          composition: '1,2,3,4,5,6,7',
          eligibilitySegment: '200000000,200000001,200000002,200000003',
          stateCode: 0,
          statusCode: 1,
        },
        {
          excess: 250,
          startDate: '2017-12-01',
          endDate: '2020-01-07',
          composition: '1,2,3,4,6,7',
          eligibilitySegment: '200000000,200000001,200000002,200000003',
          stateCode: 0,
          statusCode: 1,
        },
        {
          excess: 0,
          startDate: '2017-12-01',
          endDate: '2020-01-07',
          composition: '1,2,3,4,5,6,7',
          eligibilitySegment: '200000000,200000001,200000002,200000003',
          stateCode: 0,
          statusCode: 1,
        },
      ],
    },
  ],
};
